export default __webpack_public_path__ + "static/media/oops-something-went-wrong-large.cae9de29.png";